import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { TwoFactorSecretPayloadModel } from '@/models/auth/auth.model';

export default class TwoFactorSecretRequest extends ApiResourceMethod<TwoFactorSecretPayloadModel> {
  public perform(): Promise<TwoFactorSecretPayloadModel> {
    return this.performer.requestWithMapper(
      {},
      (payload: BaseResponse<TwoFactorSecretPayloadModel>) => ({
        qr: payload.data.qr,
        link: payload.data.link,
        secretKey: payload.data.secretKey,
      }),
    );
  }
}
